import { Button } from '@latitude/button';
import { Tag } from '@latitude/tag';
import type { ToggleGroupComponentItem } from 'types';

export const groupTypes: ToggleGroupComponentItem = {
  button: {
    component: Button,
    variant: 'neutral',
    type: 'ghost',
    size: 'tiny',
    htmlType: 'button',
  },
  tag: {
    component: Tag,
    variant: 'danger',
    fill: 'filled',
    size: 'tiny',
  },
};
